import classNames from 'classnames';
import React from 'react';
import { Button } from '../../../../UI/Common';
import { getSharedDefaultStyles, getSpacingAround } from '../functions';
import AGSection from './AGSection';
import CMVSection from './CMVSection';

const DashboardCustomWidget2 = (props) => {
  const [group, setGroup] = React.useState({
    name: '',
    state: '',
  });
  function getStyles() {
    let val = parseInt(props.values.width);
    return {
      width: Number.isNaN(val) ? '100%' : val,
      ...getSharedDefaultStyles(),
      ...getSpacingAround(
        props.values.extraProperties.spacingTop,
        props.values.extraProperties.spacingRight,
        props.values.extraProperties.spacingBottom,
        props.values.extraProperties.spacingLeft,
      ),
    };
  }
  return (
    <div
      style={getStyles()}
      className={classNames(
        props.isActive === props.values.id && 'selected-widget',
        'd-flex flex-column',
      )}
    >
      {props.shouldDisplayCMV ? (
        <div>
          <Button
            onClick={() => {
              props.updateShouldDisplayCMV(false);
              setGroup({ name: '', state: '' });
            }}
          >
            Back
          </Button>
        </div>
      ) : null}

      {props.shouldDisplayCMV ? (
        <CMVSection
          {...props}
          groupName={group.name}
          groupState={group.state}
        />
      ) : (
        <AGSection {...props} setGroup={setGroup} />
      )}
    </div>
  );
};

export default DashboardCustomWidget2;
